<template>
  <el-upload :show-file-list="false"
            style="height:0.2rem"
             ref="uploadSign"
             :action="action"
             :cathUrl="cathUrl"
             :on-success="onSuccess"
             :on-error="uploaderror"
             :headers="upLoadHeader"
             :before-upload="beforeUpload">
    <!--suppress JSUnresolvedVariable -->
    <button class="-button det-btn" @click="chageSign()"
    ><i class="el-icon-damai-daoru margin-right-4"></i>{{value}}</button>
  </el-upload>
</template>

<script>
import { nAlert, nSuccess, nWarn } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
import md5 from "js-md5";
import { errorMessage } from "../../../utils/errorCode";
import { bus } from "../../../utils/bus";

export default {
  name: "button-upload",
  props: {
    value: {
      type: String,
      default: "导入"
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    uploadSignPerson: Boolean,
    cathUrl: String,
    onSuccess: {
      type: Function,
      default(data) {
        const e = errorHandler("导入失败")(data);
        if (!(e instanceof Error)) {
          nSuccess("导入成功");
          this.$emit("getpage");
        }
      }
    }
  },
  data() {
    return {
      action: "",
      upLoadHeader: {}
    };
  },
  created() {
    this.upLoadHeader.token = bus.global.token;
    this.upLoadHeader["yq-app-code"] = bus.global.yqCode;
    this.upLoadHeader["kj-type"] = 'gy';
  },
  methods: {
    onExceed(files, fileList) {
      nWarn(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，
        共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeUpload(file) {
      console.log(file);
      // const office2003 = 'application/vnd.ms-excel'
      // const office2007 =
      //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      // if (file.type === office2007) {
      //   return true
      // }
      // if (file.type === office2003) {
      //   return true
      // }
      // nAlert('暂不支持改格式的文件，请前往右上角帮助与支持下载对应模板')
      // return false
    },
    uploaderror(err) {
      if (JSON.parse(err.message).data) {
        let url = JSON.parse(err.message).data;
        if (url) {
          let eleLink = document.createElement("a");
          eleLink.download = "未导入数据.xls";
          eleLink.style.display = "none";

          eleLink.href = url;

          document.body.appendChild(eleLink);
          eleLink.click();
          // 然后移除
          document.body.removeChild(eleLink);
          // this.$layer.toast({
          //   icon: 'icon-check',
          //   content: errorMessage(+JSON.parse(err.message).data),
          //   time: 1000
          // })
        }
      } else {
        this.$layer.toast({
          icon: "icon-check",
          content: "导入出错",
          time: 1000
        });
      }
    },
    chageSign() {
      this.action = this.cathUrl;
      // let timestamp = new Date().getTime()
      // let mainUrl = this.cathUrl
      // let newCathUrl = mainUrl.split('?')[0]
      // this.action = newCathUrl + '&timestamp=' + timestamp
      // let pUrl = newCathUrl.split('/ecard')[1].split('?')[0]
      // let allowToken = `url=/ecard${pUrl}&timestamp=${timestamp}&key=WLXXPBDBVDZYONRQW7P9XRTJFI1NXCKA`
      // let accessToken = md5(allowToken)
      // this.upLoadHeader = {
      //   'sign': accessToken
      // }
    }
  },
  watch: {
    uploadSignPerson(v) {
      // console.log(this.$refs)
      if (v === true) {
        console.log(this.$refs);
        this.$refs.uploadSign.submit();
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../styles/fun_var";

.-button {
  min-width: 80px;
  height: 32px;
  .generate-common-button(#f7f7f7);
}
.-button:hover {
  cursor: pointer;
  color: #1362ff;
  background-color: #f7f7f7;
  border: 1px solid #1362ff;
}

.det-btn {
  margin-left: 10px;
  padding: 5px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/buttons/button-upload.vue